document.addEventListener('DOMContentLoaded', function() {
    document.getElementById('search-toggle').addEventListener('click', function() {
        var container = document.querySelector('.search-form-container');
        
        if (container) {
            if(container.classList.contains('open')) {
                container.classList.remove('open');
            } else {
                container.classList.add('open');
            }
        }
    });
});
